export type Coordinate = {
    latitude: string;
    longitude: string;
};

export enum VenueType {
    Venue = 'venue',
    Google = 'google',
}
export interface VenueValues extends Coordinate {
    address: Address;
    id: string;
    name: string;
    type: VenueType;
}

export const mockVenue = (values?: Partial<VenueValues>): VenueValues => ({
    address: {
        address1: '133 Paseo de la Castellana',
        address2: 'Planta 7',
        city: 'Madrid',
        region: 'MD',
        postalCode: '28020',
        country: 'ES',
        latitude: '40.4587705',
        longitude: '-3.6911281',
        localizedAddress: '133 Paseo de la Castellana Planta 7, 28020 Madrid',
    },
    id: '35156199',
    name: 'Eventbrite Spain HQ',
    latitude: '40.4587705',
    longitude: '-3.6911281',
    type: VenueType.Venue,
    ...values,
});

export interface Address extends Coordinate {
    address1: string;
    address2: string;
    city: string;
    region: string;
    postalCode: string;
    country: string;
    localizedAddress: string;
}

type BasePlace = {
    value: string;
    content: string;
};

type VenueResult = BasePlace & {
    type: VenueType.Venue;
    data: VenueValues;
};

type GooglePlaceResult = BasePlace & {
    type: VenueType.Google;
    data: google.maps.places.AutocompletePrediction;
};

export type Place = GooglePlaceResult | VenueResult;
